import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const DevicesPage = lazy(() => import('@cobliteam/devices'));

const routes = [
  {
    path: Location.DEVICES,
    component: DevicesPage,
    exact: true,
  },
];

export default routes;
